import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { getAppInsights, getReactPlugin, getSharedAppInsightsConnectionString } from '.';
import { getAppConfig } from '../..';
export function initializeApplicationInsights(shell, remotes) {
    const config = getAppConfig();
    // allow remotes to override the connection string if needed
    const connectionString = config.REACT_APP_APPINSIGHTS_CONNECTION_STRING !== undefined
        ? config.REACT_APP_APPINSIGHTS_CONNECTION_STRING
        : getSharedAppInsightsConnectionString().getValue();
    // allow for legacy instrumentation key for now
    const connectionConfig = config.REACT_APP_APPINSIGHTS_INSTR_KEY !== undefined
        ? { instrumentationKey: config.REACT_APP_APPINSIGHTS_INSTR_KEY }
        : { connectionString };
    const reactPlugin = getReactPlugin(new ReactPlugin());
    const appInsights = getAppInsights(new ApplicationInsights({
        config: {
            ...connectionConfig,
            enableUnhandledPromiseRejectionTracking: false,
            autoTrackPageVisitTime: false,
            enableAutoRouteTracking: true,
            // Enable correlation
            enableCorsCorrelation: true,
            enableRequestHeaderTracking: false,
            enableResponseHeaderTracking: false,
            correlationHeaderDomains: [
                'mysgi.ca',
                '*.mysgi.ca',
                'sgi.sk.ca',
                '*.sgi.sk.ca',
                'sgicanada.ca',
                '*.sgicanada.ca',
                'sgicloud.ca',
                '*.sgicloud.ca',
            ],
            excludeRequestFromAutoTrackingPatterns: [
                'launchdarkly.com',
                'js.monitor.azure.com',
                'https://int.paymentui.sgicloud.ca',
                'https://parallel.paymentui.sgicloud.ca',
                'https://paymentui.sgicloud.ca',
                'https://maps.googleapis.com',
                ...(remotes?.map(remote => remote.url) ?? []),
            ],
            // End of correlation config
            extensions: [reactPlugin.getValue()],
        },
    }));
    appInsights.getValue().loadAppInsights();
    const cloudRoleName = buildCloudRoleName(config.REACT_APP_APPINSIGHTS_CLOUD_ROLE_NAME || 'AF.Shell.UI', config.REACT_APP_ENV);
    appInsights.getValue().addTelemetryInitializer((envelope) => {
        envelope.tags = envelope.tags || [];
        envelope.tags.push({ 'ai.cloud.role': cloudRoleName });
    });
}
/**
 * Builds the App Insights cloud role name based on the base name and environment.
 * @param baseName - The base name for the cloud role. This should come from the application remote configuration.
 * @param env - The environment for the cloud role. This should come from the application remote configuration.
 * @returns The built cloud role name.
 */
export function buildCloudRoleName(baseName, env) {
    let cloudRoleName = '';
    if (env === 'prd') {
        cloudRoleName = baseName;
    }
    else if (env === 'par') {
        cloudRoleName = `${baseName}-par`;
    }
    else if (env === 'int') {
        cloudRoleName = `${baseName}-int`;
    }
    else {
        cloudRoleName = `${baseName}-Development`;
    }
    return cloudRoleName;
}
